<template>
  <v-app>
    <v-toolbar dark v-if="$route.name" color="secondary lighten-5" flat app>
      <v-icon color="secondary" class="md-icon">{{$route.meta.icon}}</v-icon>
      <div class="display-1 ml-4 secondary--text">{{$t(`title.${$route.name}`)}}</div>
      <v-spacer/>
      <logo theme="dark" height="60"/>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height class="pa-0">
        <v-layout justify-center align-center>
          <router-view/>
        </v-layout>
      </v-container>
    </v-content>
    <v-snackbar
      v-model="state.message.show"
      bottom
      :color="state.message.color"
      :timeout="state.message.timeout"
    >
      {{ state.message.text }}
    </v-snackbar>
  </v-app>
</template>
<script>
import { mapState } from 'vuex'
export default {
  components: {
    Logo: () => import('@/components/Logo.vue')
  },
  computed: {
    ...mapState(['state'])
  }
}
</script>
<style lang="scss">
html {
  overflow: hidden !important;
}
.md-icon {
  font-size: 38px !important;
}
.lg-icon {
  font-size: 100px !important;
}
.xl-icon {
  font-size: 170px !important;
}
.flex-none {
  flex: none !important;
}
.align-self-center {
  align-self: center;
}
.required label::after{
  content: '*';
}
.required:not(.v-input):after {
  content: '';
}

.main-form {
  overflow: auto;
  flex: 1 auto;
}

// VUETIFY
.v-content {
  max-height: 100vh;
  .v-content__wrap {
    overflow: auto;
    position: relative;
  }
}
.v-btn:not(.v-btn--floating):not(.v-btn--icon) {
  border-radius: 5px !important;
}
</style>
